export default __webpack_public_path__ + "static/media/newSpinner.f31ccd74.gif";